<template>
  <el-container  style="display: block;">
    <el-row  class="elementsz" style="margin-top: 30px;margin-left: 30px;">
      <el-row :span="2" style="margin-top: 30px;">
          输入搜索词:<el-input v-model="name" style="width: 150px;" placeholder="请输入搜索词"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          自身机器id:<el-input v-model="myid" style="width: 150px;" placeholder="请输入id"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          互动机器id:<el-input v-model="otherid" style="width: 150px;" placeholder="请输入id"></el-input>
      </el-row>

      <el-row :span="2" style="margin-top: 30px;">
          随机句数:<el-input v-model="num" style="width: 150px;" placeholder="请输入刷新时间"></el-input>
      </el-row>

      <el-row :span="2" style="margin-top: 30px;">
         <el-col :span="3" >

           <el-input v-model="ju" style="width: 250px;" placeholder="请输入句子"></el-input>
         </el-col>

         <el-col :span="2" style="text-align: center;">
           <el-input v-model="timej" style="width: 150px;" placeholder="请输入静默时间参数"></el-input>
         </el-col>
         <el-col :span="1" style="text-align: center;">
           <el-button type="primary" style="background-color: #409eff;" @click="addTime()" round>添加句子</el-button>
         </el-col>
      </el-row>

      <el-row :span="2" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="jus"
            height="300"
          	border
          	style="width: 25%;margin-left: 0;height: 800px;text-align: center;">
          	<el-table-column
              prop="msg"
              width="363"
          	  label="句子"
          	   >

          	</el-table-column>
          	<el-table-column
              prop="timej"
              width="80"
          	  label="静默时间"
          	   >
          	</el-table-column>

            <el-table-column
              width="80"
              label="操作"
               >
               <template slot-scope="scope">
                 <i class="el-icon-delete" @click="delTime(scope.$index)"></i>
               </template>
            </el-table-column>
            </el-table>
          </template>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-button type="primary" style="background-color: #409eff;" @click="add()" round>添加</el-button>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-input v-model="seachName" style="width: 150px;" placeholder="请输入搜索词"></el-input>
          <el-button type="primary" style="background-color: #409eff;"  @click="seach()" round>搜索</el-button>

      </el-row>
    </el-row>
    <el-row  class="elementsz" style="margin-top: 30px;margin-left: 30px;">
      <template>
        <el-table
      	:data="tableData"
        height="1500"
      	border
      	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">

        <el-table-column

          width="180"
          label="名称"
           >
           <template slot-scope="scope">
               <div  @click="changeT(1,scope.row.name,scope.row.id)">{{scope.row.name}}</div>



           </template>
        </el-table-column>
      	<el-table-column

          width="180"
      	  label="自身机器id"
      	   >
           <template slot-scope="scope">
               <div  @click="changeT(2,scope.row.myid,scope.row.id)">{{scope.row.myid}}</div>



           </template>
      	</el-table-column>
        <el-table-column

          width="180"
          label="互动机器id"
           >
           <template slot-scope="scope">
               <div  @click="changeT(3,scope.row.otherid,scope.row.id)">{{scope.row.otherid}}</div>



           </template>
        </el-table-column>
        <el-table-column

          width="180"
          label="随机句数"
           >
           <template slot-scope="scope">
               <div  @click="changeT(4,scope.row.num,scope.row.id)">{{scope.row.num}}</div>



           </template>
        </el-table-column>
        <el-table-column

          width="1000"
          label="句子"
           >
           <template slot-scope="scope">

             <div  v-for="(items,indexs) in scope.row.ju" :key="indexs" @click="ct(items.id,items.msg,items.timej)">
               <el-row>
                 <div style="float: left;">{{items.msg}} </div>
                 <div style="float: left;">#{{items.timej}} </div>
                 <div style="float: left;"><i class="el-icon-circle-close" style="margin-left: 10px;" @click="delEc(items.id)"></i></div>
               </el-row>

             </div>
            <i style="margin-left: 30px;" @click="changeTime(scope.row.id)" class="el-icon-plus el-icon-circle-plus-outline"></i>
           </template>
        </el-table-column>

        <el-table-column

          width="80"
          label="操作"
           >
           <template slot-scope="scope">
             <i class="el-icon-delete" @click="delAll(scope.row.id)"></i>
           </template>
        </el-table-column>

        </el-table>
      </template>
      <div class="page">
      	<el-pagination
      	  @size-change="loadData()"
      	  @current-change="loadData()"
      	  :current-page.sync="page"
      	  :page-size="20"
      	  background
      	  layout="total,prev, pager, next, jumper"
      	  :total="count">
      	</el-pagination>
      </div>
    </el-row>
    <el-dialog
      title="修改时间段"
      :visible.sync="ctDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="ct_time"/>
      <input type="text" class="searchT" v-model="ctj_time"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="ctDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doCt()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添加"
      :visible.sync="timeVisible"
      width="30%"
      center>
      <input type="text" class="searchT" placeholder="句子" v-model="timesadd"/>
      <input type="text" class="searchT" placeholder="静默时间参数" v-model="timejadd"/>
      <span slot="footer" class="dialog-footer">
    	<el-button style="margin-top: 10px;" @click="timeVisible = false">取 消</el-button>
    	<el-button style="margin-top: 10px;" type="primary" @click="doEc()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="changes"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="centerDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doChange()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisibled"
      width="30%"
      >
      <span>确认删除？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisibled = false">取 消</el-button>
    	<el-button type="primary" @click="doDell()">确 定</el-button>
      </span>
    </el-dialog>



  </el-container>

</template>

<script>

  export default {
    data() {
       return {
         page:1,
         count:0,
         otherid: '无',
         myid:'无',
         tableData:[],
         name:'',
         dialogVisibled:false,
         delId:0,
         jus:[],
         timej:'无',
         ju:'',
         centerDialogVisible:false,
         timeVisible:false,
         ctDialogVisible:false,
         num:'无',
         seachName:'',
         juStr:'',
         c_id:0,
         ct_time:'',
         ctj_time:'',
         timesadd:'',
         timejadd:'无',
         changes:'',
         ec_id:0


      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadData();


    },

	methods:{

    seach(){
      this.loadData();
    },

    ct(id,time,bai){
      this.ct_id = id
      this.ct_time = time
      this.ctj_time = bai
      this.ctDialogVisible = true
    },
    doCt(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.ct_id,
          time:this.ct_time+'#'+this.ctj_time
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/talkmsgChange'
      })
      .then(res=>{
         this.ctDialogVisible = false
         this.ct_id = 0
         this.ct_time = ''
         this.loadData()

      })
      .catch(err=>{

      });
    },
    changeTime(id){
      this.ec_id = id
      this.timeVisible = true
    },
    addTime(){
      this.jus.push({'msg':this.ju,'timej':this.timej})
      this.zuTime()
    },
    delTime(index){
      this.jus.splice(index,1);
      this.zuTime()
    },
    zuTime(){
      let a = []
      this.jus.forEach(function(item,index){
        a.push(item.msg+'#'+item.timej)
      })
      this.juStr = a.join(',')
    },



    doEc(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.ec_id,

          time:this.timesadd+'#'+this.timejadd
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/talkmsgDoec'
      })
      .then(res=>{
         this.timeVisible = false
         this.timesadd = ''

         this.ec_id = 0

         this.loadData()

      })
      .catch(err=>{

      });
    },
    delEc(id){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/talkDelec'
      })
      .then(res=>{
         this.ctDialogVisible = false
         this.loadData()

      })
      .catch(err=>{

      });
    },
    changeT(t,n,id){
      this.c_id = id
      this.t = t
      this.changes = n
      this.centerDialogVisible = true
    },
    doChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.c_id,
          t:this.t,
          n:this.changes
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/talkChange'
      })
      .then(res=>{
         this.centerDialogVisible = false
         this.c_id = 0
         this.t = ''
         this.changes = ''
         this.loadData()

      })
      .catch(err=>{

      });
    },
    delAll(id){
      this.delId = id
      this.dialogVisibled = true
    },


    doDell(){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.delId,

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/talkDel'
      })
      .then(res=>{
         this.dialogVisibled = false
         this.loadData()

      })
      .catch(err=>{

      });
    },


    add(){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          name:this.name,
          myid:this.myid,
          otherid:this.otherid,
          num:this.num,
          ju:this.juStr,

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/talkAdd'
      })
      .then(res=>{
         this.loadData()
         this.name = ''
         this.juStr = ''
         this.jus = []

      })
      .catch(err=>{

      });
    },
    loadData(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{
          t:this.pait,
          p:this.page,
          name:this.seachName,
          type:1,
          y_t:1
    		},
    		url:'http://y31p.yoooooo.com/index.php/index/data/talkList'
    	})
    	.then(res=>{
        this.seeimgVisiblec = false;
    		this.tableData = res.data.list;
    		this.count = res.data.count;

    	})
    	.catch(err=>{

    	});
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .pai{
    background-color:rgb(64, 158, 255);
  }
</style>



// WEBPACK FOOTER //
// src/components/main/talk.vue